import Solution from '../models/Solution';
import Data from './Data';

class Solutions extends Data {
    constructor() {
        super(Solution);
    }

    async getForType(type) {
        return this.all().then(
            solutions => solutions.filter(solution => solution.type === type),
        );
    }

    async getForCategory(category) {
        return this.all().then(
            solutions => solutions.filter(solution => solution.hasCategory(category)),
        );
    }
}

export default new Solutions();
